import config from "Configurations";
import { apiRequest } from "util/services";

export const fetchCrmConnection = () => apiRequest("feedback/crm-connection", "GET", null, true);

export const createCrmKey = () => apiRequest("feedback/crm-connection/key", "POST", {}, true);

export const revokeCrmKey = () => apiRequest("feedback/crm-connection/key", "DELETE", null, true);

// The company's do-not-call list: numbers come back partly hidden, each with a ref to remove it by.
export const fetchDoNotCall = () => apiRequest("feedback/crm-connection/do-not-call", "GET", null, true);

export const addDoNotCall = (phone) => apiRequest("feedback/crm-connection/do-not-call", "POST", { phone }, true);

export const removeDoNotCall = (ref) =>
  apiRequest(`feedback/crm-connection/do-not-call?ref=${encodeURIComponent(ref)}`, "DELETE", null, true);

// The address a company's CRM posts its events to (no session: the company key guards it).
export const crmWebhookUrl = () => `${config.BASE_URL}feedback/hooks/crm`;
